import { Card, CardBody, Col, Form } from 'reactstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import { BloodHoundHeading } from '../../../../../Utils/Constants'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'
import { bloodHoundData, stateOfUsa } from '../../../../../Data/Forms/FormsWidgets/Typeahead/Typeahead'

const BloodHound = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={BloodHoundHeading} span={bloodHoundData} />
        <CardBody>
          <div id="bloodhound">
            <Form className="theme-form">
              <div>
                <Typeahead options={stateOfUsa} placeholder="States of USA" id="BloodHound" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BloodHound